import { getLeakUnitsAPI, getOveruseUnitsAPI } from "@/apis/analysis-api"
import { getDongHoInfoAPI } from "@/apis/apt-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { create } from "zustand"

export const unitsStore = create((set, get) => ({
  // INFO: 아파트 전체의 동/호 정보 불러오기
  apiGetDongHoInfo: async ({ kapt_code }) => {
    const dongHo = await getDongHoInfoAPI({ kapt_code })
    return { originDongs: Object.keys(dongHo), dongHo }
  },

  apiInitial: async () => {
    const { sido, kapt_code } = aptSearchStore.getState().pickApt
    const { buildUnitStatusMap } = get()

    const leak_units = await getLeakUnitsAPI({ sido, kapt_code, dong: "all" })
    const overuse_units = await getOveruseUnitsAPI({ sido, kapt_code, dong: "all" })

    const dongHo = await getDongHoInfoAPI({ kapt_code })

    buildUnitStatusMap({ leak_units, overuse_units, dongHo })
    set({
      originDongs: Object.keys(dongHo),
      dongHo
    })
  },

  // INFO: 헤더에서 선택 중
  draftDong: "",
  draftHo: "",
  setDraftDong: (dong) => set({ draftDong: dong }),
  setDraftHo: (ho) => set({ draftHo: ho }),

  // 원천 Raw 데이터만 보관 (UI 가공은 컴포넌트에서 수행)
  originDongs: [],
  dongHo: {},

  // 동/호별 상태 메타데이터 (누수, 과다사용 배지 카운트 정보)
  unitStatusMap: {},

  // INFO: 누수 + 과다사용 상태 구조적 merge
  buildUnitStatusMap: ({ leak_units = [], overuse_units = [], dongHo }) => {
    if (!Object.keys(dongHo).length) return

    const map = {}
    // 1. 전체 동/호 구조 기본 뼈대 세팅
    Object.entries(dongHo).forEach(([dong, hos]) => {
      map[dong] = {
        dongBadges: {},
        hos: {}
      }

      hos.forEach((ho) => {
        map[dong].hos[ho] = {
          badges: []
        }
      })
    })

    // 2. 누수 정보 merge
    leak_units.forEach((item) => {
      const dong = Number(item.dong)
      const ho = Number(item.ho)

      if (!map[dong]?.hos?.[ho]) return

      const badges = map[dong].hos[ho].badges
      if (!badges.includes("leak")) {
        badges.push("leak")
      }

      map[dong].dongBadges.leak = (map[dong].dongBadges.leak || 0) + 1
    })

    // 3. 과다사용 정보 merge
    overuse_units.forEach((item) => {
      const dong = Number(item.dong)
      const ho = Number(item.ho)

      const { resource } = item
      if (!map[dong]?.hos?.[ho]) return

      const badges = map[dong].hos[ho].badges
      if (!badges.includes(resource)) {
        badges.push(resource)
      }

      map[dong].dongBadges[resource] = (map[dong].dongBadges[resource] || 0) + 1
    })

    set({ unitStatusMap: map })
  },

  closeModal: () => set({ isOpen: false }),

  // 불필요했던 스토어 내부 상태값 초기화 제거 및 싱크 매칭
  reset: () =>
    set({
      draftDong: "",
      draftHo: "",
      originDongs: [],
      dongHo: {},
      unitStatusMap: {}
    })
}))
